import { Observable } from 'rxjs';
import {
  CDCSubscriptionData,
  SubscriptionBaseData,
  SubscriptionCheckData,
  SubscriptionData,
  SubscriptionLocation,
  SubscriptionSettingCollection,
  SubscriptionSettingVersion,
  SubscriptionSettingVersionList,
} from '../../model/subscription.model';

export abstract class NewsLetterAdapter {
  abstract subscribe(data: SubscriptionData): Observable<string>;
  abstract unsubscribe(data: SubscriptionBaseData): Observable<string>;
  abstract getSubscription(): Observable<SubscriptionSettingCollection>;
  abstract subscribeRegistrationCDC(data: CDCSubscriptionData): Observable<string>;
  abstract getSubscriptionByLocation(location: SubscriptionLocation): Observable<SubscriptionSettingVersion[]>;
}
